export enum ObjectStatusText {
  DRAFT = 'RASCUNHO SALVO',
  PUBLISHED = 'PUBLICADO',
}
